import { Store } from 'vuex'
import Vue from 'vue'
import Router, { NavigationGuard, RouterOptions } from 'vue-router'
import Home from '@/views/Home.vue'
import Pilot from '@/views/pilot/index.vue'
import Login from '@/views/Login.vue'
import ChangePassword from '@/views/ChangePassword.vue'
import CreatePassword from '@/views/CreatePassword.vue'
import GlobalMission from '@/views/pilot/GlobalMission.vue'
import GlobalFleet from '@/views/pilot/GlobalFleet.vue'
import Mission from '@/views/pilot/Mission.vue'
import Maintenance from '@/views/maintenance/index.vue'
import Configuration from '@/views/configuration/index.vue'
import Training from '@/views/training/index.vue'
import Planning from '@/views/planning/index.vue'
import Smart from '@/views/smart/index.vue'
import SmartSimulationDetailPage from '@/components/smart/SimulationDetailPage.vue'
import SmartDetailDrawer from '@/components/smart/SmartDetailDrawer.vue'
import PlanningDrawerInformation from '@/components/smart/PlanningDrawerInformation.vue'
import PlanningPage from '@/components/smart/PlanningPage.vue'
import Debug from '@/views/debug/index.vue'
import Test from '@/views/debug/test.vue'
import FleetList from '@/components/fleet/FleetList.vue'
import MissionList from '@/components/mission/MissionList.vue'
import MissionPage from '@/components/mission/MissionPage.vue'
import MissionSearch from '@/components/mission/MissionSearch.vue'
import MissionDrawerFilter from '@/components/mission/MissionDrawerFilter.vue'
import MissionDrawerInformation from '@/components/mission/MissionDrawerInformation.vue'
import Cache from '@/views/pilot/CacheGraphs.vue'
import CacheSearch from '@/components/cache/CacheSearch.vue'
import CachePage from '@/components/cache/CachePage.vue'
import Fleet from '@/views/pilot/Fleet.vue'
import FleetPage from '@/components/fleet/FleetPage.vue'
import FleetSearch from '@/components/fleet/FleetSearch.vue'
import FleetDrawerFilter from '@/components/fleet/FleetDrawerFilter.vue'
import FleetDrawerInformation from '@/components/fleet/FleetDrawerInformation.vue'
import HomeAdmin from '@/components/admin/HomeAdmin.vue'
import HomeConfiguration from '@/components/configuration/HomeConfiguration.vue'
import ConfigurationMenu from '@/components/configuration/ConfigurationMenu.vue'
import AdminGlider from '@/components/admin/glider/AdminGlider.vue'
import AdminGliderList from '@/components/admin/glider/AdminGliderList.vue'
import AdminGliderMenu from '@/components/admin/glider/AdminGliderMenu.vue'
import Fiche from '@/components/admin/Fiche.vue'
import AdminEnseigne from '@/components/admin/enseigne/AdminEnseigne.vue'
import AdminEnseigneList from '@/components/admin/enseigne/AdminEnseigneList.vue'
import AdminPositionRemarquable from '@/components/admin/positionRemarquable/AdminPositionRemarquable.vue'
import AdminPositionRemarquableList from '@/components/admin/positionRemarquable/AdminPositionRemarquableList.vue'
import AdminMapLayer from '@/components/admin/mapLayer/AdminMapLayer.vue'
import AdminMapLayerList from '@/components/admin/mapLayer/AdminMapLayerList.vue'
import UploadFile from '@/components/admin/UploadFile.vue'
import AdminUmbClasse from '@/components/admin/umbClasse/AdminUmbClasse.vue'
import AdminUmbClasseList from '@/components/admin/umbClasse/AdminUmbClasseList.vue'
import AdminUmbType from '@/components/admin/umbType/AdminUmbType.vue'
import AdminUmbTypeList from '@/components/admin/umbType/AdminUmbTypeList.vue'
import AdminRole from '@/components/admin/role/AdminRole.vue'
import AdminRoleList from '@/components/admin/role/AdminRoleList.vue'
import AdminUser from '@/components/admin/user/AdminUser.vue'
import AdminUserRightsTab from '@/components/admin/user/AdminUserRightsTab.vue'
import AdminUserPasswordTab from '@/components/admin/user/AdminUserPasswordTab.vue'
import AdminUserList from '@/components/admin/user/AdminUserList.vue'
import AdminUserMenu from '@/components/admin/user/AdminUserMenu.vue'
import AdminUniteMobile from '@/components/admin/uniteMobile/AdminUniteMobile.vue'
import AdminUniteMobileList from '@/components/admin/uniteMobile/AdminUniteMobileList.vue'
import AdminMesureType from '@/components/admin/mesureType/AdminMesureType.vue'
import AdminMesureTypeList from '@/components/admin/mesureType/AdminMesureTypeList.vue'
import AdminMesureUnite from '@/components/admin/mesureUnite/AdminMesureUnite.vue'
import AdminMesureUniteList from '@/components/admin/mesureUnite/AdminMesureUniteList.vue'
import AdminAdminMission from '@/components/admin/adminMission/AdminAdminMission.vue'
import AdminAdminMissionList from '@/components/admin/adminMission/AdminAdminMissionList.vue'
import AdminAdminMissionMenu from '@/components/admin/adminMission/AdminAdminMissionMenu.vue'
import AdminMissionUserRightsTab from '@/components/admin/adminMission/AdminMissionUserRightsTab.vue'
import AdminMissionPlanTab from '@/components/admin/adminMission/AdminMissionPlanTab.vue'
import AdminMissionPlanTemplateList from '@/components/admin/missionPlanTemplate/AdminMissionPlanTemplateList.vue'


import AdminAdminFleet from '@/components/admin/adminFleet/AdminAdminFleet.vue'
import AdminAdminFleetList from '@/components/admin/adminFleet/AdminAdminFleetList.vue'
import AdminAdminFleetMenu from '@/components/admin/adminFleet/AdminAdminFleetMenu.vue'
import AdminFleetConfigTab from '@/components/admin/adminFleet/AdminFleetConfigTab.vue'
import AdminCmdCompletion from '@/components/admin/cmdCompletion/AdminCmdCompletion.vue'
import AdminMsgAccueil from '@/components/admin/msgAccueil/AdminMsgAccueil.vue'
import AdminNmea from '@/components/admin/nmea/AdminNmea.vue'
import AdminHomeImage from '@/components/admin/image/AdminHomeImage.vue'
import AdminPasswordPolicy from '@/components/admin/passwordPolicy/AdminPasswordPolicy.vue'

import DebugFilter from '@/components/admin/debug/DebugFilter.vue'


import types from '@/store/all-mutation-types'
import { IRootState } from '@/store'

Vue.use(Router)

export default (store: Store<IRootState>) => {
  const router = new Router({
    // mode: 'history',
    routes: [
      {
        path: '/',
        name: 'Home',
        component: Home
      },
      {
        path: '/login',
        name: 'Login',
        component: Login
      },
      {
        path: '/create-password',
        name: 'CreatePassword',
        component: CreatePassword
      },
      {
        path: '/change-password',
        name: 'ChangePassword',
        component: ChangePassword
      },
      {
        path: '/debug',
        name: 'Debug',
        component: Debug,
        meta: {
          rightDrawerCmp: DebugFilter
        },
               
      },      
      {
        path: '/debug/test',
        name: 'Test',
        component: Test,                      
      },
      {
        path: '/smartplanning',     
        component: Smart,   
        meta: {},
        children:[
          {
            path: '',
            name: 'SmartPlanning',
            component: PlanningPage,   
            meta:{
              rightDrawerCmp: PlanningDrawerInformation,
              hideRightDrawer: false                                
            }         
          },                   
          {
            path: ':simulationid',
            name: 'SmartPlanningDetail',
            component: SmartSimulationDetailPage,           
            props(route) {              
              return { ...route.params, simulationid:parseInt(route.params.simulationid) }
            },
            meta:{                              
              rightDrawerCmp: SmartDetailDrawer,
              hideRightDrawer: false                                
            }
          }
        ]       
      },
      {
        path: '/fleet',
        component: Fleet,
        meta: {},
        children: [
          {
            path: '',
            component: GlobalFleet,
            name: 'Fleet',
            meta: {
              rightDrawerCmp: FleetList
            }
          }
        ]
      },
      {
        path: '/pilot',
        component: Pilot,
        meta: {},
        children: [
          {
            path: '',
            component: GlobalMission,
            name: 'Pilot',
            meta: {
              rightDrawerCmp: MissionList
            }
          },
          {
            path: 'mission',            
            component: Mission,
            meta: {
              rightDrawerCmp: MissionDrawerInformation,
              hideRightDrawer: 'auto'
            },
            children: [
              {
                path: '',
                name: 'Mission',
                component: MissionSearch,
                meta:{
                  rightDrawerCmp: MissionDrawerFilter
                }

              },
              {
                path: ':missionid',
                name: 'MissionDetail',
                component: MissionPage,                
                props(route) {              
                  return { ...route.params, missionid:parseInt(route.params.missionid) }
                },
                /*meta:{                              
                  hideRightDrawer:false,                  
                }*/
              }
            ]
          },
          {
            path: 'fleet',            
            component: Fleet,
            meta: {
              rightDrawerCmp: FleetDrawerInformation,
              hideRightDrawer: 'auto'
            },
            children: [
              {
                path: '',
                name: 'Fleet',
                component: FleetSearch,
                meta:{
                  rightDrawerCmp: FleetDrawerFilter
                }

              },
              {
                path: ':fleetid',
                name: 'FleetDetail',
                component: FleetPage,                
                props(route) {              
                  return { ...route.params, fleetid:parseInt(route.params.fleetid) }
                },
                /*meta:{                              
                  hideRightDrawer:false,                  
                }*/
              }
            ]
          },
          {
            path: 'cache',            
            component: Cache,
            meta: {              
              hideRightDrawer: true
            },
            children: [
              {
                path: '',
                name: 'Cache',
                component: CacheSearch,                
              },
              {
                path: ':missionid',
                name: 'CacheDetail',
                component: CachePage,                
                props(route) {              
                  return { ...route.params, missionid:parseInt(route.params.missionid) }
                },
                /*meta:{                              
                  hideRightDrawer:false,                  
                }*/
              }
            ]
          }
        ]
      },
      {
        path: '/configuration',        
        component: Configuration,
        children: [
          {
            path: '',
            name: 'Configuration',
            component: HomeConfiguration,              
            meta:{
              drawerCmp: ConfigurationMenu
            }         
          }/*,  
          {            
            path: 'maplayer',
            name: 'NewMapLayer',
            component: AdminMapLayer,              
            meta:{
              drawerCmp: ConfigurationMenu,            
              rightDrawerCmp: AdminMapLayerList,
              hideDrawer:true
            }
          },
          {            
            path: 'maplayer/:itemid',
            name: 'EditMapLayer',
            component: AdminMapLayer,
            props(route) {              
              return { ...route.params, itemid:parseInt(route.params.itemid) }
            },
            meta:{
              drawerCmp: ConfigurationMenu,
              rightDrawerCmp: AdminMapLayerList,
              hideDrawer:true
            }
          },
          {            
            path: 'uploadFile',
            name: 'UploadFile',
            component: UploadFile,              
            meta:{
              drawerCmp: ConfigurationMenu,                          
              hideDrawer:true
            }
          } */      
        ]
      },
      {
        path: '/maintenance',        
        component: Maintenance,
        children: [
          {
            path: '',
            name: 'Maintenance',
            component: HomeAdmin,            
          },
          {            
            path: 'gliders',
            name: 'NewGlider',
            component: AdminGlider,              
            meta:{
              rightDrawerCmp: AdminGliderList
            }
          },
          {            
            path: 'gliders/:itemid',
            component: AdminGliderMenu,
            children:[
              {
                path:'',
                name:'EditGlider',
                component: Fiche,
                props(route) {              
                  return { ...route.params, itemid:parseInt(route.params.itemid), itemTypeName:'Glider'  }
                },
                meta:{
                  rightDrawerCmp: AdminGliderList
                }
              },
              {
                path:'form',
                name:'FormGlider',
                component: AdminGlider,
                props(route) {              
                  return { ...route.params, itemid:parseInt(route.params.itemid) }
                },
                meta:{
                  rightDrawerCmp: AdminGliderList
                }
              },
              {
                path:'documents',
                name:'DocumentsGlider',
                component: AdminGlider,
                props(route) {              
                  return { ...route.params, itemid:parseInt(route.params.itemid) }
                },
                meta:{
                  rightDrawerCmp: AdminGliderList
                }
              },
              {
                path:'mobil-units',
                name:'MobilUnitsGlider',
                component: AdminGlider,
                props(route) {              
                  return { ...route.params, itemid:parseInt(route.params.itemid) }
                },
                meta:{
                  rightDrawerCmp: AdminGliderList
                }
              }
            ]
          },
          {            
            path: 'enseignes',
            name: 'NewEnseigne',
            component: AdminEnseigne,              
            meta:{
              rightDrawerCmp: AdminEnseigneList
            }
          },
          {            
            path: 'enseignes/:itemid',
            name: 'EditEnseigne',
            component: AdminEnseigne,
            props(route) {              
              return { ...route.params, itemid:parseInt(route.params.itemid) }
            },
            meta:{
              rightDrawerCmp: AdminEnseigneList
            }
          },  
          {            
            path: 'maplayer',
            name: 'NewMapLayer',
            component: AdminMapLayer,              
            meta:{
              drawerCmp: ConfigurationMenu,            
              rightDrawerCmp: AdminMapLayerList,
              hideDrawer:true
            }
          },
          {            
            path: 'maplayer/:itemid',
            name: 'EditMapLayer',
            component: AdminMapLayer,
            props(route) {              
              return { ...route.params, itemid:parseInt(route.params.itemid) }
            },
            meta:{
              drawerCmp: ConfigurationMenu,
              rightDrawerCmp: AdminMapLayerList,
              hideDrawer:true
            }
          },
          {            
            path: 'uploadFile',
            name: 'UploadFile',
            component: UploadFile,              
            meta:{
              drawerCmp: ConfigurationMenu,                          
              hideDrawer:true
            }
          },
          {            
            path: 'positionremarquable',
            name: 'NewPositionRemarquable',
            component: AdminPositionRemarquable,              
            meta:{
              rightDrawerCmp: AdminPositionRemarquableList              
            }
          },
          {            
            path: 'positionremarquable/:itemid',
            name: 'EditPositionRemarquable',
            component: AdminPositionRemarquable,
            props(route) {              
              return { ...route.params, itemid:parseInt(route.params.itemid) }
            },
            meta:{
              rightDrawerCmp: AdminPositionRemarquableList
            }
          },         
          {
            path: 'umbClasses',
            name: 'NewUmbClasse',
            component: AdminUmbClasse,              
            meta:{
              rightDrawerCmp: AdminUmbClasseList
            }
          },
          {            
            path: 'umbClasses/:itemid',
            name: 'EditUmbClasse',
            component: AdminUmbClasse,
            props(route) {              
              return { ...route.params, itemid:parseInt(route.params.itemid) }
            },   
            meta:{
              rightDrawerCmp: AdminUmbClasseList
            }

          },        
          {
            path: 'umbTypes',
            name: 'NewUmbType',
            component: AdminUmbType,              
            meta:{
              rightDrawerCmp: AdminUmbTypeList
            }
          },
          {            
            path: 'umbTypes/:itemid',
            name: 'EditUmbType',
            component: AdminUmbType,
            props(route) {              
              return { ...route.params, itemid:parseInt(route.params.itemid) }
            },    
            meta:{
              rightDrawerCmp: AdminUmbTypeList
            }

          },   
          {
            path: 'roles',
            name: 'NewRole',
            component: AdminRole,              
            meta:{
              rightDrawerCmp: AdminRoleList
            }
          },
          {            
            path: 'roles/:itemid',
            name: 'EditRole',
            component: AdminRole,
            props(route) {              
              return { ...route.params, itemid:parseInt(route.params.itemid) }
            },    
            meta:{
              rightDrawerCmp: AdminRoleList
            }
          },        
          {
            path: 'users',
            name: 'NewUser',
            component: AdminUser,              
            meta:{
              rightDrawerCmp: AdminUserList
            }
          },
          {            
            path: 'users/:itemid',
            component: AdminUserMenu,
            children:[
              {
                path:'',
                name: 'EditUser',
                component: Fiche,
                props(route) {              
                  return { ...route.params, itemid:parseInt(route.params.itemid), itemTypeName:'User' }
                },    
                meta:{
                  rightDrawerCmp: AdminUserList
                }
              },
              {
                path:'form',
                name:'FormUser',
                component: AdminUser,
                props(route) {              
                  return { ...route.params, itemid:parseInt(route.params.itemid) }
                },
                meta:{
                  rightDrawerCmp: AdminUserList
                }
              },
              {
                path:'droits',
                name:'DroitsUser',
                component: AdminUserRightsTab,
                props(route) {              
                  return { ...route.params, itemid:parseInt(route.params.itemid) }
                },
                meta:{
                  rightDrawerCmp: AdminUserList
                }
              },
              {
                path:'change-password',
                name:'PasswordUser',
                component: AdminUserPasswordTab,
                props(route) {              
                  return { ...route.params, itemid:parseInt(route.params.itemid) }
                },
                meta:{
                  rightDrawerCmp: AdminUserList
                }
              },
              
            ]            
          },        
          {
            path: 'uniteMobiles',
            name: 'NewUniteMobile',
            component: AdminUniteMobile,              
            meta:{
              rightDrawerCmp: AdminUniteMobileList
            }
          },
          {            
            path: 'uniteMobiles/:itemid',
            name: 'EditUniteMobile',
            component: AdminUniteMobile,
            props(route) {              
              return { ...route.params, itemid:parseInt(route.params.itemid) }
            },    
            meta:{
              rightDrawerCmp: AdminUniteMobileList
            }
          },        
          {
            path: 'mesureType',
            name: 'NewMesureType',
            component: AdminMesureType,              
            meta:{
              rightDrawerCmp: AdminMesureTypeList
            }
          },
          {            
            path: 'mesureType/:itemid',
            name: 'EditMesureType',
            component: AdminMesureType,
            props(route) {              
              return { ...route.params, itemid:parseInt(route.params.itemid) }
            },    
            meta:{
              rightDrawerCmp: AdminMesureTypeList
            }
          },        
          {
            path: 'mesureUnite',
            name: 'NewMesureUnite',
            component: AdminMesureUnite,              
            meta:{
              rightDrawerCmp: AdminMesureUniteList
            }
          },
          {            
            path: 'mesureUnite/:itemid',
            name: 'EditMesureUnite',
            component: AdminMesureUnite,
            props(route) {              
              return { ...route.params, itemid:parseInt(route.params.itemid) }
            },    
            meta:{
              rightDrawerCmp: AdminMesureUniteList
            }
        } ,        
        {
          path: 'mission',
          name: 'NewAdminMission',
          component: AdminAdminMission,              
          meta:{
            rightDrawerCmp: AdminAdminMissionList
          }
        },
          {            
            path: 'mission/:itemid',            
            component: AdminAdminMissionMenu,
            children:[
              {
                path:'',
                name:'EditAdminMission',
                component: Fiche,            
                props(route) {              
                  return { ...route.params, itemid:parseInt(route.params.itemid), itemTypeName:'AdminMission' }
                }, 
                meta:{
                  rightDrawerCmp: AdminAdminMissionList
                }
              },
              {
                path:'form',
                name:'FormAdminMission',
                component: AdminAdminMission,            
                props(route) {              
                  return { ...route.params, itemid:parseInt(route.params.itemid) }
                }, 
                meta:{
                  rightDrawerCmp: AdminAdminMissionList
                }
              },
              {
                path:'droits',
                name:'DroitsAdminMission',
                component: AdminMissionUserRightsTab,            
                props(route) {              
                  return { ...route.params, itemid:parseInt(route.params.itemid) }
                }, 
                meta:{
                  rightDrawerCmp: AdminAdminMissionList
                }
              },
              {
                path:'planification',
                name:'MissionPlan',
                component: AdminMissionPlanTab,            
                props(route) {              
                  return { ...route.params, itemid:parseInt(route.params.itemid) }
                }, 
                meta:{
                  rightDrawerCmp: AdminAdminMissionList
                }
                
              }
            ]
          }  ,        
          {
            path: 'fleet',
            name: 'NewAdminFleet',
            component: AdminAdminFleet,              
            meta:{
              rightDrawerCmp: AdminAdminFleetList
            }
          },
          {            
            path: 'fleet/:itemid',            
            component: AdminAdminFleetMenu,
            children:[
              {
                path:'',
                name:'EditAdminFleet',
                component: Fiche,            
                props(route) {              
                  return { ...route.params, itemid:parseInt(route.params.itemid), itemTypeName:'AdminFleet' }
                }, 
                meta:{
                  rightDrawerCmp: AdminAdminFleetList
                }
              },
              {
                path:'form',
                name:'FormAdminFleet',
                component: AdminAdminFleet,            
                props(route) {              
                  return { ...route.params, itemid:parseInt(route.params.itemid) }
                }, 
                meta:{
                  rightDrawerCmp: AdminAdminFleetList
                }
              },
              {
                path:'config',
                name:'ConfigAdminFleet',
                component: AdminFleetConfigTab,            
                props(route) {              
                  return { ...route.params, itemid:parseInt(route.params.itemid) }
                }, 
                meta:{
                  rightDrawerCmp: AdminAdminFleetList
                }
              }
            ]
          },        
          {
            path: 'command',
            name: 'CmdCompletion',
            component: AdminCmdCompletion,              
            meta:{              
            }
          },
          {
            path: 'message',
            name: 'MsgAccueil',
            component: AdminMsgAccueil,              
            meta:{              
            }
          },
          {
            path: 'nmea',
            name: 'Nmea',
            component: AdminNmea,              
            meta:{              
            }
          },
          {
            path: 'image',
            name: 'Image',
            component: AdminHomeImage,              
            meta:{              
            }
          },
          {
            path: 'pwdPolicy',
            name: 'PwdPolicy',
            component: AdminPasswordPolicy,              
            meta:{              
            }
          },
          
        ]
      },
      {
        path: '/training',
        name: 'Training',
        component: Training
      },
      {
        path: '/planning',
        name: 'NewMissionPlanTemplate',
        component: Planning,
        meta:{
          rightDrawerCmp: AdminMissionPlanTemplateList
        }
      },
      {            
        path: '/planning/:itemid',
        name: 'EditMissionPlanTemplate',
        component: Planning,
        props(route) {              
          return { ...route.params, itemid:parseInt(route.params.itemid) }
        },    
        meta:{
          rightDrawerCmp: AdminMissionPlanTemplateList
        }
      }
    ] 
  } as RouterOptions)

  //mise ne place de la securité test pour chaque route demandée
  router.beforeEach(((to, from, next) => {    
    if (to.path == '/login'|| to.path == '/create-password') {
      //si on est pas authentifié on reste sur la page login
      if (!store.getters.isAuthenticated) {
        next()
        return
      }
      next('/')
    } else {
      //si on est authentifié c'est bon
      if (store.getters.isAuthenticated) {        
        next()
        return
      }
      next('/login')
    }
  }) as NavigationGuard)

  return router
}

